import {
  QSetSimilarityCheckResultDetailsPageHeader,
  QSetSimilarityCheckResultDetailsProvider,
} from '@exam-management/qset-check-similarity-result';
import { useParams } from '@exam-management/router';
import { Outlet } from 'react-router-dom';

export default function QSetSimilarityCheckResultDetailsLayout() {
  const { resultId, comparisonId } = useParams(
    '/exam-courses/:courseId/qsets/similarity-check/results/:resultId/:comparisonId',
  );
  return (
    <QSetSimilarityCheckResultDetailsProvider resultId={resultId} comparisonId={comparisonId}>
      <QSetSimilarityCheckResultDetailsPageHeader />
      <Outlet />
    </QSetSimilarityCheckResultDetailsProvider>
  );
}
